<ng-container *transloco="let convert;">
  <app-modal modalId="Save-Comment">
    @if (state === 'loading') {
      <app-action-submitting actionText="{{convert('shared.saveComment.actionTextSubmittingComment')}}"></app-action-submitting>
    }
    @if (state === 'success') {
      <app-action-submitted
        (close)="close()"
        actionText="{{convert('shared.saveComment.actionTextCommentSaved')}}"
        [tenantName]="tenantName"
      ></app-action-submitted>
    }
    @if (state === 'error') {
      <app-action-error
        (close)="close()"
        [tenantName]="tenantName"
        [errorText]="errorText"
      ></app-action-error>
    }
  </app-modal>
</ng-container>
